// extracted by mini-css-extract-plugin
module.exports = {"housemateContainer":"style_housemateContainer__2XvwW"};